(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ContractGrossEstimateController', ContractGrossEstimateController);

    ContractGrossEstimateController.$inject = ['$scope', 'ContractCustomService', 'XLSXExportService', 'ToastrService', 'MiscService', 'DateUtils'];

    function ContractGrossEstimateController($scope, ContractCustomService, XLSXExportService, ToastrService, MiscService, DateUtils) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.downloadReport = downloadReport;
        vm.openCalendar = openCalendar;
        vm.refresh = refresh;
        vm.onStartDateChange = onStartDateChange;
        vm.lastDayOfMonth = lastDayOfMonth;
        vm.resetForm = resetForm;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        resetForm();

        function openCalendar( date ) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadAll() {
            vm.contractsList = [];
            vm.statusText = "Fetching Contracts";
            ContractCustomService.returnGrossEstimateContracts(DateUtils.convertLocalDateToServer(vm.startDate), DateUtils.convertLocalDateToServer(vm.endDate),
                vm.contractStatus, vm.contractCat, vm.contractSubCat).then(function( result ) {
                vm.contractsList = result.data;
                generateStatusText();
                if( vm.contractsList.length < 1 ) {
                    vm.statusText = "No Contracts fetched with given date range";
                    ToastrService.info(vm.statusText, "Info");
                }
            }, function( error ) {
                vm.statusText = "Failed to fetch Contracts";
                if(error.status !== "404") {
                    ToastrService.error(vm.statusText, "Error");
                }
            });
        }

        function downloadReport() {
            if(vm.contractsList.length > 0) {
                XLSXExportService.downloadGrossEstimateContractsReport(vm.contractsList).then( function( data, status, headers, config ) {
                    var file = new Blob([data.data], {type: 'application/vnd.ms-excel'});
                    saveAs(file, "ContractsGrossEstimate.xls");
                }, function(error) {
                    if(error.status !== "404") {
                        ToastrService.error("Failed to download Contracts Gross Estimate Report", "Error");
                    }
                });
            } else {
                ToastrService.info("Nothing to download", "Info");
            }
        }

        function refresh() {
            loadAll();
        }

        function resetForm() {
            vm.contractsList = [];
            vm.startDate = MiscService.generateStartDate( new Date() );
            vm.endDate = MiscService.generateEndDate( new Date() );
            vm.statusText = "Waiting for Command...";
            vm.contractStatus = {draft:true, issued:true, complete:false, signed:false, cancelled:false};
            vm.contractCat = {japan:true, tui:true};
            vm.contractSubCat = {subCatJapan:true, subCatOutside:true, subCatPurchase:true, subCatDirect:true};
        }

        function onStartDateChange() {
            vm.endDate = MiscService.onStartDateChange( vm.startDate, vm.endDate );
        }

        function lastDayOfMonth() {
            vm.endDate = MiscService.generateLastDayOfMonth( vm.endDate );
        }

        function generateStatusText() {
            if( vm.startDate.getTime() === vm.endDate.getTime() ) {
                vm.statusText = "Showing " + vm.contractsList.length + " Contracts for " + vm.startDate.toLocaleDateString("en-US");
            } else {
                vm.statusText = "Showing " + vm.contractsList.length + " Contracts from " + vm.startDate.toLocaleDateString("en-US") + " to " + vm.endDate.toLocaleDateString("en-US");
            }
        }
    }
})();
